import "./index.scss"
import Acc_type from "../../assets/images/accountType.svg"
import Image from "lib/Image";

const RadioCheckbox = (props) => {
  const { name, onChange, options, validators } = props;
  return (
      <div className="rc-container">
        {options?.map((option) => {
          const { id, label, sublabel } = option;
          let radioId = name + id;

          return (
            <label className="radio_checkbox" htmlFor={radioId} key={radioId} validators={validators}>
              <input
                id={radioId}
                type="radio"
                name={name}
                className="rc-input"
                onChange={onChange}
                value={label}
              />
              <div className="dot"></div>
              <div className="rc-label">
                <Image imageSrc ={Acc_type}/>
                <span>{label}</span>
                <p className="sub_label">{sublabel}</p>
              </div>
            </label>
          );
        })}
      </div>
  );
};
export default RadioCheckbox